import React, { useEffect, useRef, useState } from 'react';
import SeriesList from "@/components/video/seriesList/index"
import BlackDropDown from "@/assets/icons/blackDropDown.png"
import WhiteDropDown from "@/assets/icons/whiteDropDown.png"
import GreyLine from "@/assets/icons/greyLine.png"

import "./style.css"
import { addCurrentThemeClassToEle } from '@/utils';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { themes } from '@/constants/colors_v2';
import { useSafeAreaInsets } from '@/hooks/useSafeAreaInsets';


const BottomSeries = (props: any) => {
    const { currentVideoObj, seriesDetails, updateCurrentVideoObj, isLoading } = props
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);
    const { bottom: bottomSafeBottom } = useSafeAreaInsets();
    const [isOpen, setIsOpen] = useState(false);
    const [dragY, setDragY] = useState(0);
    const panelRef = useRef<HTMLDivElement>(null);

    const handleOpen = () => setIsOpen(true);
    const handleClose = (videoDocId: any = null) => {
        setDragY(0);
        setIsOpen(false);
        if (videoDocId) {
            updateCurrentVideoObj(videoDocId)
        }
    };

    const startY = useRef(0);
    const isDragging = useRef(false);

    const handleStart = (e: React.TouchEvent | React.MouseEvent) => {
        isDragging.current = true;
        startY.current =
            'touches' in e ? e.touches[0].clientY : (e as React.MouseEvent).clientY;
    };

    const handleMove = (e: React.TouchEvent | React.MouseEvent) => {
        if (!isDragging.current) return;
        const currentY =
            'touches' in e ? e.touches[0].clientY : (e as React.MouseEvent).clientY;
        const diffY = currentY - startY.current;

        if (diffY > 0) {
            setDragY(diffY);
        }
    };

    const handleEnd = () => {
        isDragging.current = false;
        if (dragY > 100) {
            handleClose();
        } else {
            setDragY(0);
        }
    };

    // Lock/unlock body scroll when panel is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    return (
        <div className={`bottomSeriesViewMain ${addCurrentThemeClassToEle(currentTheme, 'bottomSeriesViewMain')}`}>
            {/* Sticky bottom trigger button */}
            <div
                onClick={handleOpen}
                className="fixCon"
            >
                <div 
                 className='flex flex-row justify-space-between items-center'
                 style={{
                    flex: 1,   
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: bottomSafeBottom ? bottomSafeBottom+'px' : ''
                }}>
                    <div className='flex items-center gap-[10px]'>
                        <img
                            className='thumbnailUrl'
                            src={currentVideoObj.thumbnailUrl}
                            alt='thumbnailUrl' />
                        <p className='videoTitle'>{currentVideoObj.title}</p>
                    </div>
                    <img
                        className='w-[12px]'
                        src={currentTheme === themes.dark ? WhiteDropDown : BlackDropDown}
                        about='BlackDropDown' />
                </div>
            </div>

            {/* Sliding Panel */}
            <div
                ref={panelRef}
                className={`panelRef02 fixed left-0 right-0 bottom-0 shadow-lg rounded-t-lg transition-transform duration-300 ease-out`}
                style={{
                    height: '50vh',
                    transform: isOpen ? `translateY(${dragY}px)` : 'translateY(100%)',
                    touchAction: 'none',
                }}
                onTouchStart={handleStart}
                onTouchMove={handleMove}
                onTouchEnd={handleEnd}
                onMouseDown={handleStart}
                onMouseMove={handleMove}
                onMouseUp={handleEnd}
                onMouseLeave={handleEnd}
            >
                {/* Fixed Header */}
                <div className="panelHeading">
                    <img
                        className='w-[90px] h-[4px]'
                        src={GreyLine} alt='GreyLine' />
                </div>

                {/* Scrollable Content */}
                {/* <div className="overflow-y-auto h-full"> */}
                <div className="overflow-y-auto overflow-x-hidden h-full">
                    <SeriesList
                        seriesDetails={seriesDetails}
                        updateCurrentVideoObj={(videoDocId: any) => handleClose(videoDocId)}
                        isLoading={isLoading}
                        bottomSeriesIsOpen={isOpen}
                        currentVideoObj={currentVideoObj}
                        isWelcomeSeries={props?.isWelcomeSeries || false}
                    />

                </div>
            </div>
        </div>
    );
};

export default BottomSeries;
